import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const SCOPE_AR = { sheikh: 'تقرير شيخ', sponsor: 'تقرير داعم', general: 'عام' };

export default function ReportTemplates() {
  const { api } = useAuth();
  const toast = useToast();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scope, setScope] = useState('');

  const load = () => {
    setLoading(true);
    const qs = scope ? `?scope=${scope}` : '';
    api(`/report-templates${qs}`).then(setList).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(load, [scope]);

  const setDefault = async (t) => {
    try {
      await api(`/report-templates/${t.id}`, {
        method: 'PUT',
        body: JSON.stringify({ is_default: true }),
      });
      toast.success('تم تعيينه افتراضياً');
      load();
    } catch (err) { toast.error(err.message); }
  };

  const remove = async (t) => {
    if (!window.confirm(`حذف القالب "${t.name}"؟`)) return;
    try {
      await api(`/report-templates/${t.id}`, { method: 'DELETE' });
      toast.success('تم الحذف');
      load();
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>قوالب التقارير</h2>
      </div>

      <div className="card" style={{ padding: 14, marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          تُحفظ القوالب من داخل صفحات تقرير الشيخ أو الداعم بعد تخصيص الفلاتر والأعمدة. قالب واحد افتراضي لكل نوع.
        </div>
      </div>

      <div className="filters" style={{ marginBottom: 16 }}>
        <select className="form-select" value={scope} onChange={e => setScope(e.target.value)}>
          <option value="">كل الأنواع</option>
          {Object.entries(SCOPE_AR).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
      </div>

      {loading ? <div className="loader">جاري التحميل...</div> :
       list.length === 0 ? <div className="card"><div className="empty"><div className="empty-icon">📋</div>لا توجد قوالب محفوظة</div></div> : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>الاسم</th><th>النوع</th><th>افتراضي</th><th>تفاصيل الإعداد</th><th>إجراءات</th></tr></thead>
              <tbody>
                {list.map(t => (
                  <tr key={t.id}>
                    <td style={{ fontWeight: 500 }}>{t.name}</td>
                    <td><span className="badge">{SCOPE_AR[t.scope] || t.scope}</span></td>
                    <td>{t.is_default ? '★ افتراضي' : <button className="btn btn-sm btn-outline" onClick={() => setDefault(t)}>تعيين افتراضي</button>}</td>
                    <td style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                      {t.config?.columns?.length ? `${t.config.columns.length} عمود` : '—'}
                      {t.config?.group_by && t.config.group_by !== 'none' ? ` • تجميع: ${t.config.group_by}` : ''}
                    </td>
                    <td>
                      <button className="btn btn-sm btn-outline" onClick={() => remove(t)} style={{ color: 'var(--danger)' }}>حذف</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
